module.exports = __webpack_public_path__ + "img/media (21).7baf1314.png";